import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const defaultContext = {
    formIsDisabled: false,
    formIsLiteral: false
};
const Context = createContext(defaultContext);
Context.displayName = "FormState";
export const FormProvider = Context.Provider;
export function useFormState() {
    return useContext(Context);
}
export function FormStateProvider({ initialState, children }) {
    return _jsx(FormProvider, { value: initialState, children: children });
}
//# sourceMappingURL=FormContext.js.map